import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import ModalKeyword from "../modal-keyword/component";
import {dataRegister} from "../../services/dataRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {userRegister} from "../../services/userRegister";
import {BeatLoader} from "react-spinners";
import {scraperRegister} from "../../services/scraperRegister";
import Typist from 'react-typist';

class IndustrySearch extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isLoadingUrl: false,
            dropdown: false,
            industry: null,
            search: "",
            industries: [],
            index: -1,
            url_response: {},
            user: {}
        };
        this._setKeyword = this._setKeyword.bind(this);
    };

    componentWillMount() {
        //document.addEventListener("keydown", this._handleKeyDown.bind(this));
    }

    componentWillUnmount() {
        //document.removeEventListener("keydown", this._handleKeyDown.bind(this));
    }

    componentDidMount() {
        this.industry.update();
        this.update.data();
        this.update.user();
    }

    /*
    _handleKeyDown(event){
        var ARROW_DOWN = 40;
        var ARROW_UP = 38;
        var ENTER = 13;
        switch( event.keyCode ) {
            case ARROW_DOWN:
                if(this.state.industries.length > 0 && this.state.dropdown) {

                    let industries = this.state.industries.filter((item) => {
                        return item.name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                    });
                    industries.map((item => {return item.active = false}));

                    let index = this.state.index + 1;
                    if(industries[index]){
                        industries[index].active = true;
                        this.state.index = index;
                    }else{
                        this.state.index = 0;
                        industries[this.state.index].active = true;
                    }

                    this.setState({industries: this.state.industries, index: this.state.index});
                }
                break;
            case ARROW_UP:
                if(this.state.industries.length > 0 && this.state.dropdown) {

                    let industries = this.state.industries.filter((item) => {
                        return item.name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                    });
                    industries.map((item => {return item.active = false}));

                    let index = this.state.index - 1;
                    if(industries[index]){
                        industries[index].active = true;
                        this.state.index = index;
                    }else{
                        this.state.index = 0;
                        industries[this.state.index].active = true;
                    }

                    this.setState({industries: this.state.industries, index: this.state.index});
                }
                break;
            case ENTER:
                for(let i = 0; i < this.state.industries.length; i++){
                    if(this.state.industries[i].active){
                        this._selectIndustry(this.state.industries[i]);
                        break;
                    }
                }
                break;
            default:
                break;
        }
    }
    */

    _setKeyword(keyword) {
        if (keyword) {
            this.setState({keyword: false, search: ""});
        } else {
            this.setState({keyword: false});
        }
    }

    _reset() {
        this.setState({search: "", industry: null}, () => {
            this.props.selectIndustry(null);
        });
    }

    update = {
        user: () => {
            let user = userRegister.get();
            this.setState({user: user ? user : {}});
        },
        data: () => {
            try {
                if (this.props.industry) {
                    this.setState({
                        industry: this.props.industry,
                        search: this.props.industry.name
                    });
                }
            } catch (e) {
                this.setState({industry: null});
            }
        }
    };

    /*
    functions = {
        checkLink: () => {
            this.setState({isLoadingUrl: true}, () => {
                dataRegister.checkScraperLink(this.state.search, langRegister.lang()).then((response) => {
                    this.setState({url_response: response, isLoadingUrl: false});
                }, (error) => {
                    this.setState({isLoadingUrl: false, url_response: {}});
                });
            });
        }
    };
    */

    industry = {
        update: () => {
            dataRegister.getIndustries(salesChannelRegister.get("market"), langRegister.lang(), this.state.search, 50).then((response) => {
                this.setState({industries: response});
            }, (error) => {
                console.log(error);
            });
        },
        select: (value) => {
            try {
                this.refs.search.blur();
                this.props.selectIndustry(value);
                this.setState({search: value.name, dropdown: false});
            } catch (e) {
                this.props.selectIndustry(value);
                this.setState({search: value.name, dropdown: false});
            }
        },
        filter: (search) => {
            let industries = [];
            let exact = [];
            let first = [];
            let contains = [];
            let pattern = new RegExp('^' + search.toLowerCase());
            for (let i = 0; i < this.state.industries.length; i++) {
                if (this.state.industries[i].name.toLowerCase() === search.toLowerCase()) {
                    exact.push(this.state.industries[i]);
                } else if (this.state.industries[i].name.toLowerCase().indexOf(search.toLowerCase()) !== 1 && !pattern.test(this.state.industries[i].name.toLowerCase())) {
                    contains.push(this.state.industries[i]);
                } else if (pattern.test(this.state.industries[i].name.toLowerCase())) {
                    first.push(this.state.industries[i]);
                }
            }
            industries = exact.concat(first, contains);
            return industries;
        }
    };

    /*
    scraper = {
        set: () => {
            if(this.state.url_response.available && (this.state.user.reseller || this.state.inhouse)){
                this.setState({isLoading: true}, () => {
                    this.props.setloader(true);
                    dataRegister.scrapeLink(this.state.url_response.url, this.state.url_response.scraper_id, langRegister.lang()).then((response) => {
                        scraperRegister.set(response);
                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/industry");
                    }, (error) => {
                        scraperRegister.removeScraperData();
                        this.setState({isLoadingUrl: false, url_response: {}}, () => {
                            this.props.setloader(false);
                        });
                    });
                });
            }
        },
        remove: () => {

        },
        check: () => {

        },
        reset: () => {

        }
    };
    */

    validators = {
        website: (value) => {
            var re = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
            return re.test(String(value).toLowerCase());
        }
    };

    renders = {
        text: (item) => {
            return langRegister.get("industry-search", item);
        },
        /*
        scraperDropdown: () => {
            return(
                <div className={Styles.sectionOneRightIndustryDropdown}>
                    {
                        this.state.isLoadingUrl &&
                        <div className={Styles.sectionOneRightIndustryDropdownItemExtra}>
                            {this.renders.text("item_7")}
                        </div>
                    }
                    {
                        !this.state.isLoadingUrl && this.state.url_response.available &&
                        <div onClick={() => {this.scraper.set()}} className={Styles.sectionOneRightIndustryDropdownItemExtra}>
                            <span className={Styles.sectionOneRightIndustryDropdownItemExtraBold}>{this.state.url_response.location}&nbsp;</span>
                            <span className={Styles.sectionOneRightIndustryDropdownItemExtraBoldGreen}>{" "}{this.renders.text("item_5")}</span>
                        </div>
                    }
                    {
                        !this.state.isLoadingUrl && !this.state.url_response.available &&
                        <div className={Styles.sectionOneRightIndustryDropdownItemExtra}>
                            {this.renders.text("item_6")}
                        </div>
                    }
                </div>
            )
        }
        */
        saleschanneldemo: () => {
            try {
                return false//salesChannelRegister.get('name') === 'saleschanneldemo';
            } catch (e) {
                return false;
            }
        }
    };

    _renderText(item) {
        return langRegister.get("industry-search", item);
    }

    render() {
        return (
            <div className={Styles.view}>
                {
                    this.state.keyword &&
                    <ModalKeyword initKeyword={this.state.search} setKeyword={this._setKeyword} props={this.props}/>
                }
                {
                    this.state.industry &&
                    <div className={Styles.title}>
                        {this._renderText("item_4")}
                    </div>
                }
                <div className={
                    cx(Styles.sectionOneRightIndustry,
                        {
                            [Styles.sectionOneRightIndustrySelected]: this.state.industry,
                            [Styles.sectionOneRightIndustryNotSelected]: !this.state.industry,
                        })
                }>
                    {
                        this.state.industry &&
                        <img onClick={() => this._reset()}
                             className={Styles.sectionOneRightIndustryCloseButton}
                             src={require("../../assets/images/close_icon_white_2.svg")}/>
                    }
                    {
                        this.state.industry &&
                        <div className={Styles.sectionOneRightSelectedIndustryContainer}>
                            <div className={Styles.sectionOneRightSelectedIndustryContainerText}>
                                {this.state.search}
                            </div>
                        </div>
                    }
                    {
                        !this.state.industry &&
                        <div className={Styles.inputContainer}>
                            <input
                                ref='search'
                                onKeyDown={(event) => {
                                    try {
                                        var key = event.charCode || event.keyCode || 0;
                                        if (key === 13) {
                                            event.preventDefault();
                                            return false;
                                        }
                                    } catch (e) {
                                    }
                                }}
                                onFocus={() => {
                                    if (!this.state.industry) {
                                        this.setState({dropdown: true});
                                    }
                                }}
                                onBlur={() => {
                                    this.state.industries.map((item) => {
                                        item.active = false
                                    });
                                    this.setState({dropdown: false})
                                }}
                                value={this.state.search}
                                onChange={(event) => {
                                    this.setState({search: event.target.value}, () => {
                                        this.industry.update();
                                    })
                                }}
                                placeholder={this._renderText("item_1")}
                                className={
                                    cx(Styles.sectionOneRightIndustryInput,
                                        {
                                            [Styles.sectionOneRightIndustryInputDisabled]: this.state.industry,
                                            [Styles.sectionOneRightIndustryInputSelected]: this.state.industry,
                                        })
                                }/>
                            <div onClick={() => {
                                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/industry")
                            }} className={Styles.inputContainerListButton}>
                                <img className={Styles.inputContainerListButtonIcon}
                                     src={require("../../assets/images/list_icon.svg")}/>
                            </div>
                        </div>
                    }
                    {
                        this.state.industry &&
                        <div className={Styles.sectionOneRightIndustryInputDisabledOverlay}/>
                    }
                    {
                        this.state.dropdown && !this.validators.website(this.state.search) &&
                        <div className={Styles.sectionOneRightIndustryDropdown}>
                            {
                                this.industry.filter(this.state.search).map((prop, i) => {
                                    if(this.renders.saleschanneldemo() && prop.type === "1"){
                                        return (
                                            <div key={i} onMouseDown={() => this.industry.select(prop)}
                                                 className={
                                                     cx(Styles.sectionOneRightIndustryDropdownItem,
                                                         {
                                                             [Styles.sectionOneRightIndustryDropdownItemActive]: prop.active,
                                                         })
                                                 }>
                                                <div className={Styles.sectionOneRightIndustryDropdownItemTitle}>
                                                    {prop.name}
                                                </div>
                                                {
                                                    prop.owned_by &&
                                                    <img className={Styles.sectionOneRightIndustryDropdownIcon}
                                                         src={require("../../assets/images/user_green.svg")}/>
                                                }
                                            </div>
                                        )
                                    }else if(!this.renders.saleschanneldemo()){
                                        return (
                                            <div key={i} onMouseDown={() => this.industry.select(prop)}
                                                 className={
                                                     cx(Styles.sectionOneRightIndustryDropdownItem,
                                                         {
                                                             [Styles.sectionOneRightIndustryDropdownItemActive]: prop.active,
                                                         })
                                                 }>
                                                <div className={Styles.sectionOneRightIndustryDropdownItemTitle}>
                                                    {prop.name}
                                                </div>
                                                {
                                                    prop.owned_by &&
                                                    <img className={Styles.sectionOneRightIndustryDropdownIcon}
                                                         src={require("../../assets/images/user_green.svg")}/>
                                                }
                                            </div>
                                        )
                                    }
                                })

                            }
                            {
                                this.industry.filter(this.state.search).length < 1 && this.state.dropdown &&
                                <div onMouseDown={() => this.setState({keyword: true})}
                                     className={Styles.sectionOneRightIndustryDropdownItemExtra}>
                                    {this._renderText("item_2")}&nbsp;<span
                                    className={Styles.sectionOneRightIndustryDropdownItemExtraBold}>{this.state.search}</span>?&nbsp;
                                    <span
                                        className={Styles.sectionOneRightIndustryDropdownItemExtraBoldGreen}>{this._renderText("item_3")}</span>
                                </div>
                            }

                        </div>
                    }
                    {
                        this.validators.website(this.state.search) && false &&
                        this.renders.scraperDropdown()
                    }
                </div>
            </div>
        );
    }
}

export default IndustrySearch;


// WEBPACK FOOTER //
// ./src/components/industry-search/component.js